import _ from 'lodash';
import { IProduct } from '@/service/types';
import { IProductState } from '../types';

export default {
  getAll(state: IProductState) {
    return _.get(state, `products`, {});
  },
  getByEan(state: any, getters: any) {
    return (ean: string): IProduct|boolean => {
      let result = _.find(getters.getAll, (item: IProduct) => {
        return item.ean === ean;
      });
      return typeof result !== 'undefined' ? result : false;
    };
  },
  getFromOtherByEan(state: any, getters: any) {
    return (ean: string): IProduct|boolean => {
      const other = _.get(state, `otherProducts`, {});
      let result = _.find(other, (item: IProduct) => {
        return item.ean === ean;
      });
      return typeof result !== 'undefined' ? result : false;
    };
  },
  get(state: IProductState) {
    return (id: string) => {
      return _.get(state.products, id, false);
    }
  }
}